
export default function EventInfo() {
  const features = [
    {
      icon: 'ri-run-line',
      title: 'Carrera Nocturna',
      description: 'Una experiencia única corriendo por las calles iluminadas de Zaragoza en la noche de fin de año.'
    },
    {
      icon: 'ri-shirt-line',
      title: 'Disfraces Creativos',
      description: 'Ven con tu disfraz más original y diviértete mientras corres. ¡La creatividad no tiene límites!'
    },
    {
      icon: 'ri-group-line',
      title: 'Ambiente Festivo',
      description: 'Únete a miles de corredores en una celebración llena de alegría y buen ambiente.'
    },
    {
      icon: 'ri-map-2-line',
      title: 'Centro Histórico',
      description: 'Recorre los lugares más emblemáticos del centro de Zaragoza en un circuito de 5 kilómetros.'
    },
    {
      icon: 'ri-trophy-line',
      title: 'Para Todos',
      description: 'Una carrera popular abierta a corredores de todos los niveles y edades.'
    },
    {
      icon: 'ri-heart-line',
      title: 'Tradición',
      description: 'Forma parte de la XX edición de esta querida tradición zaragozana de fin de año.'
    }
  ];

  return (
    <section id="informacion" className="py-20 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Una Carrera <span className="text-red-600">Única</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            La XX San Silvestre Zaragoza El Rincón es mucho más que una carrera. 
            Es una celebración, una tradición y una forma especial de despedir el año 
            corriendo por las calles más bonitas de nuestra ciudad.
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
          {features.map((feature, index) => (
            <div 
              key={index}
              className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 border border-gray-100"
            >
              <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mb-6">
                <i className={`${feature.icon} text-2xl text-red-600`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">{feature.title}</h3>
              <p className="text-gray-600 leading-relaxed">{feature.description}</p>
            </div>
          ))}
        </div>

        {/* Event Details */}
        <div className="bg-red-600 rounded-3xl p-8 md:p-12 text-white">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <h3 className="text-3xl md:text-4xl font-bold mb-6">
                Detalles del Evento
              </h3>
              <div className="space-y-6">
                <div className="flex items-start">
                  <div className="w-12 h-12 bg-white/20 rounded-full flex items-center justify-center mr-4 flex-shrink-0">
                    <i className="ri-calendar-event-line text-xl"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-lg mb-1">Fecha y Hora</h4>
                    <p className="text-white/90">Miércoles, 31 de Diciembre de 2025 a las 18:00 horas</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <div className="w-12 h-12 bg-white/20 rounded-full flex items-center justify-center mr-4 flex-shrink-0">
                    <i className="ri-map-pin-2-line text-xl"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-lg mb-1">Punto de Salida</h4>
                    <p className="text-white/90">Calle Coso, frente al Teatro Principal</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <div className="w-12 h-12 bg-white/20 rounded-full flex items-center justify-center mr-4 flex-shrink-0">
                    <i className="ri-route-line text-xl"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-lg mb-1">Recorrido</h4>
                    <p className="text-white/90">5 kilómetros por las calles más céntricas de Zaragoza</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <div className="w-12 h-12 bg-white/20 rounded-full flex items-center justify-center mr-4 flex-shrink-0">
                    <i className="ri-group-2-line text-xl"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-lg mb-1">Participantes</h4>
                    <p className="text-white/90">Máximo 5.000 corredores inscritos</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="relative">
              <img 
                src="https://public.readdy.ai/ai/img_res/e973ad682dd47b1a4b52a1929fcf2079.jpg"
                alt="Corredores en la San Silvestre Zaragoza"
                className="rounded-2xl shadow-2xl w-full h-80 object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent rounded-2xl"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}